import React from "react";
import { SearchResultImage } from "~assets/frontend/frame/frm-search/components/SearchResultImage";
import { SearchResultText } from "~assets/frontend/frame/frm-search/components/SearchResultText";
import { SecondaryButton } from "~assets/frontend/elements/button/Buttons";
import Translator from "bazinga-translator";
import { useLoadingMore, useSearchActions } from "~assets/frontend/frame/frm-search/store/SearchStore";
import { Loading } from "~assets/frontend/frame/frm-search/components/Loading";
export const SearchFacet = ({ facetName, items, total }) => {
    const { loadMore } = useSearchActions();
    let loadingMore = useLoadingMore();
    return (React.createElement("div", null,
        React.createElement("div", { className: "grid grid-cols-2 gap-x-12 gap-y-24 md:gap-x-36 xl:grid-cols-4" },
            React.createElement("h3", { className: "headline-3 col-span-2 mb-0 xl:col-span-4" }, Translator.trans("frm-search.facets." + facetName, {}, "frontend")),
            items.map((item, index) => {
                switch (facetName) {
                    case "inspirations":
                    case "products":
                        return React.createElement(SearchResultImage, Object.assign({ key: index }, item, { imageBorder: false }));
                    case "downloads":
                        return (React.createElement(SearchResultImage, Object.assign({ key: index }, item, { icon: {
                                position: "start",
                                className: "mr-6",
                                identifier: "icon-download",
                            }, imageBorder: true })));
                    case "misc" || "blog":
                    default:
                        return React.createElement(SearchResultText, Object.assign({ key: index }, item));
                }
            })),
        total > items.length && (React.createElement(React.Fragment, null,
            loadingMore === facetName && (React.createElement("div", { className: "mt-36" },
                React.createElement(Loading, null))),
            loadingMore !== facetName && (React.createElement("div", { className: "mt-12 flex justify-end" },
                React.createElement(SecondaryButton, { label: Translator.trans("frm-search.loadMore", {}, "frontend"), icon: { position: "start", identifier: "icon-plus", className: "mr-6" }, onClick: (event) => {
                        loadMore(facetName);
                        event.currentTarget.blur();
                    } })))))));
};
